import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const roleStep: Step = {
    id: OnboardingFlows.Seniority,
    title: `What's your role?`,
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Executive (C-Level / VP)',
        },
        {
            label: 'Department lead',
        },
        {
            label: 'Team manager',
        },
        {
            label: 'Team member',
        },
        {
            label: 'Freelancer / Solo-preneur',
        },
    ],
};
